<template>
  <div v-if="overview">
    <div class="withdrawal-summary" v-if="role === 'admin'">
      <h2 class="listing-title">總覽</h2>
      <div class="row">
        <div class="mb-2 order-4 col-6 col-md-4 col-xl-4">
          <div class="withdrawal-item d-flex flex-wrap">
            <div class="haft">
              <span class="withdrawal-item__amount">商戶可收取總額</span>
              <span class="withdrawal-item__label">
                {{ overview.available | dollarFormat }}
              </span>
            </div>
          </div>
        </div>
        <div class="mb-2 order-4 col-6 col-md-4 col-xl-4">
          <div class="withdrawal-item d-flex flex-wrap">
            <div class="haft">
              <span class="withdrawal-item__amount">
                商戶處理中總額
              </span>
              <span class="withdrawal-item__label">
                {{ overview.pending | dollarFormat }}
              </span>
            </div>
          </div>
        </div>
        <div class="mb-2 order-4 col-6 col-md-4 col-xl-4">
          <div class="withdrawal-item d-flex flex-wrap">
            <div class="haft">
              <span class="withdrawal-item__amount">
                商戶已收取總額
              </span>
              <span class="withdrawal-item__label">
                {{ overview.finished | dollarFormat }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="withdrawal-summary" v-if="role === 'merchant'">
      <h2 class="listing-title">銷售總合</h2>
      <div class="pink-tips">
        溫馨提示 商戶需自行申請收款
        <img class="overview-item__icon"
             src="../../assets/img/help-24px-blue.svg"
             alt="Hover for help"
             id="tooltip-merchant-cash-out"
        />
        <b-tooltip
          target="tooltip-merchant-cash-out"
          placement="top"
          variant="light"
        >
          當符合收款要求，可於付費優惠券>收款狀態申請收款。
        </b-tooltip>
      </div>
      <div class="row">
        <div class="mb-2 order-4 col-12 col-xl-5">
          <div class="withdrawal-item d-flex flex-wrap">
            <div class="left-item col-6 col-xl-4 p-0">
              <span class="withdrawal-item__amount">
                可收取總金額
                <img
                  src="../../assets/img/help-24px-blue.svg"
                  alt="Hover for help"
                  id="tooltip-price"
                  class="tooltips"
                />
                <b-tooltip target="tooltip-price" placement="right" variant="light">
                  <p>可收取總金額或會包含申請退款中之金額，最終可收取總金額將會根據退款情況於月結單上顯示。</p>
                </b-tooltip>
              </span>
              <span class="withdrawal-item__label">
                {{ overview.available | dollarFormat }}
              </span>
            </div>
            <div class="divide-line"></div>
            <div class="middle-item col-5 col-xl-4 p-0">
              <span class="withdrawal-item__amount">處理中款項</span>
              <span class="withdrawal-item__label">
                {{ overview.pending | dollarFormat }}
              </span>
            </div>
            <div class="right-item col-12 col-xl-3 p-0">
              <b-button v-if="overview.status.isAllow || !overview.status.hasPendingWithdrawal"
                        variant="success"
                        :disabled="loading"
                        class="withdraw"
                        @click="prepareWidthdraw('ALLOW')">
                收款申請
              </b-button>
              <b-button v-else
                        variant="light"
                        disabled
                        class="withdraw">
                匯款處理中
              </b-button>
            </div>
          </div>
        </div>
        <div class="mb-2 order-4 col-12 col-xl-3">
          <div class="withdrawal-item d-flex flex-wrap">
            <div class="haft">
              <span class="withdrawal-item__amount">已收取款項</span>
              <span class="withdrawal-item__label">{{ overview.finished | dollarFormat }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WithdrawIsAllowModal v-model="withdrawIsAllowModal"
                          :overview="overview"
    ></WithdrawIsAllowModal>
  </div>
</template>
<script>

import {
  BButton,
  BTooltip,
} from 'bootstrap-vue';
import WithdrawIsAllowModal from '@/components/record/WithdrawIsAllowModal.vue';
import dollarFormat from '@/helpers/currency';

export default {
  components: {
    BButton,
    WithdrawIsAllowModal,
    BTooltip,
  },
  props: {
    role: String,
    loading: Boolean,
    overview: Object,
  },
  filters: {
    dollarFormat,
  },
  data: () => ({
    withdrawIsAllowModal: {
      modal: false,
      action: null,
      remarks: null,
    },
  }),
  methods: {
    async prepareWidthdraw(action) {
      this.withdrawIsAllowModal = {
        modal: true,
        action,
        remarks: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.listing-title {
  font-weight: 500;
  margin-bottom: 1rem;
  color: #174169;
  font-size: 18px;
  display: inline-block;
}

.withdrawal-summary {
  .row {
    margin: 0 -6px;
    display: flex;
  }

  .mb-2 {
    padding: 0 6px;
  }

  .pink-tips {
    background: #FFF2F2;
    color: #F47E7E;
    box-sizing: border-box;
    padding: 5px 10px;
    display: inline-block;
    font-size: 14px;
    border: 1px solid #F8E6E6;
    border-radius: 5px;
    margin-left: 10px;
  }
}

.withdrawal-item {
  border: 1px solid #dde1e5;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 20px 18px 20px 20px;
  box-sizing: border-box;

  &:hover {
    & img {
      transform: scale(1.06);
    }
  }

  & img.tooltips {
    margin-top: -3px;
  }

  &__label {
    color: #174169;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 36px;
    display: block;
    font-family: Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    padding-top: 10px;

    @media (max-width: 1200px) {
      font-size: 1.5rem;
      padding-top: 0px;
    }
  }

  &__amount {
    color: #696969;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 21px;
    display: block;
  }

  .withdraw {
    margin-top: 15px;
    font-weight: 0;
    width: 100%;
  }

  .divide-line {
    background: #ccc;
    width: 1px;
    height: 50px;
    margin-top: 10px;
    display: inline-block;
    margin-right: 15px;

    @media (max-width: 1200px) {
      height: 40px;
    }
  }

  @media (max-width: 1400px) {
    .left-item, .middle-item, .right-item {
      margin: 0px;
      padding: 0px;
      text-align: left;
    }
  }
}
</style>
